enum UiSourceEnum {
    ExpressQuote = 'EXPRESS_QUOTE',
    BrokerPortal = 'BROKER_PORTAL',
    ReferralPartner = 'REFERRAL_PARTNER',
}

export default UiSourceEnum;
